import CommonHeader from '../pages/Head'
import React from 'react'
import axios from 'axios';


class ChangePWD extends React.Component {	
	constructor(props) {
		super(props);
		this.state = {manageaction:'CLIENTLOGIN',profileid:'', Resp:'',user:localStorage.getItem('tokens')};		
		this.handleChange=this.handleChange.bind(this);			
		this.handleSubmit=this.handleSubmit.bind(this);	
	}

	
	handleChange = event => {	
		const {name, value} = event.target				
		this.setState({[name]: value})		
	}
	
	handleSubmit = event => {
		event.preventDefault()		
		const {profileid} = this.state	
		if(!profileid){
			alert('Please enter client profileID')
			return false
		}
		const userObject={
				user:this.state.user,
				manageaction:this.state.manageaction,
				profileid:this.state.profileid
			}
			axios.post(process.env.REACT_APP_API_ENV+'api/managementprocess.php', userObject)
				.then((res) => {						
					this.setState({Resp:res.data});											
				}).catch((error) => {
					console.log(error)
				});
	}
	
	render() {							
		return (
			<div>			
				<CommonHeader titles="Password"/>
				<form onSubmit={this.handleSubmit}>	
					<h3 style={{textAlign:"center"}}>Update Client Password</h3><br/><br/>
					<div style={{textAlign:"center"}}>
						<label style={{width: '150px',display:'inline-block',textAlign:'right'}}>Client Profile ID</label>	
						<input name="profileid" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'5px'}} value = {this.state.profileid} onChange={this.handleChange} /><br/><br/>
						<h3>{this.state.Resp}</h3><br/><br/>
						<button type="submit" className="btn btn-primary mr-2" width="200px">&nbsp;Submit &nbsp;</button> &nbsp;&nbsp;<br/><br/>					
					</div>
				</form>
			</div>
		)
	}
}

export default ChangePWD;
	